import { mock$beGetPosIntentStatus } from 'actions/mock/castor.mock';
import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beGetPosIntentStatus';
const AT = actionType(ATAG);

// SEE: https://github.com/getslick/api.core/blob/staging/docs/pos.md
const beGetPosIntentStatus = (options) =>
  endpoint(H.get, 'payments/stripe/status/intent/:salonId/:readerId/:paymentIntentId/', {
    AT,
    name: ATAG,
    params: {
      salonId: options?.salonId,
      readerId: options?.readerId,
      paymentIntentId: options?.paymentIntentId,
    },
    data: {},
    mock: mock$beGetPosIntentStatus,
  });

beGetPosIntentStatus.AT = AT;
beGetPosIntentStatus.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beGetPosIntentStatus;
